module.exports = __webpack_public_path__ + "img/img03.31505af6.png";